<template lang="pug">
v-card(flat tile )
    v-snackbar(v-model="showErrorSnackbar" color="error")
      span {{ $t('errors.passwordNotSaved') }}
    v-snackbar(v-model="showSavedSnackbar" color="success")
      span {{ $t('boarderDetailDialog.passwordSaved') }}
    v-form(v-model="isFormValid" ref="form" @submit.prevent="onFormSubmit" :disabled="fetchInProgress" && "isFetchInProgress")
        v-card-text
            v-row.ma-0
                v-col.pa-0(cols="12")
                    v-text-field(readonly :label="$t('boarderDetailDialog.userNameLabel')" outlined v-model="loginName" disabled :loading="fetchInProgress" :rules="loginNameRules")
                v-col.pa-0(cols="12" sm="12" md="9" lg="9")
                    v-text-field(:label="$t('boarderDetailDialog.passwordLabel')" outlined :rules="passwordRules" v-model="password" :loading="fetchInProgress")
                v-col.text-md-end.pt-md-3.pa-0(cols="12" sm="12" md="3" lg="3")
                    v-btn(color="primary" @click="generateCodeClick" medium :disabled="isFetchInProgress") {{ $t('boarderDetailDialog.generatePassword') }}
            v-row.ma-0.mt-0
                v-col.pt-0(cols="9")
                v-col.text-end.pt-0.pa-0(cols="12" sm="12" md="4" lg="4" justify="end" align="end")
                    v-checkbox(
                      v-model="isCheckboxTrue"
                      on-icon="fas fa-check-square"
                      off-icon="far fa-square"
                      :label="$t('boarderDetailDialog.changeCredentialsData')")
                v-col.text-end.pt-2.pa-0(cols="12" sm="12" md="4" lg="4" justify="end" align="end")
                  v-checkbox(
                    v-model="isChangePin"
                    on-icon="fas fa-check-square"
                    off-icon="far fa-square"
                    :label="$t('boarderDetailDialog.isPinChange')")
        v-card-actions
              v-spacer
              v-btn(color="primary" type="submit"  :disabled="!isFormValid" :loading="isFetchInProgress") {{ $t('boarderDetailDialog.saveCredentials') }}

</template>

<script lang="ts">
import Vue from 'vue'
import {Component, Prop, Ref} from 'vue-property-decorator'
import {TranslateResult} from 'vue-i18n'
import i18n from '@/i18n'
import {Action} from "vuex-class";
import {
  FETCH_PERSON_CREDENTIAL_BY_ID,
  UPDATE_PERSON_CREDENTIAL_PASS_BY_ID
} from "@/store/action-types";
import {UpdatePasswordPayload} from "@/types/payload";

function valueIsRequired(v: string): boolean | TranslateResult {
  return !!v || i18n.t('validation.valueIsRequired')
}

function passwordLength(v: string): boolean | TranslateResult {
  if (v) {
    return v.length >= 4 || i18n.t('validation.passwordIsTooShort')
  }

  return false
}

@Component({})
export default class CredentialsTab extends Vue {
  @Ref('form') readonly form!: Vue & { validate(): boolean }
  @Prop({type: Number}) readonly personId!: number
  @Action(FETCH_PERSON_CREDENTIAL_BY_ID) fetchPersonCredentialById!: { (payload: number): Promise<string> }
  @Action(UPDATE_PERSON_CREDENTIAL_PASS_BY_ID) updatePersonCredentialPassById!: { (payload: UpdatePasswordPayload): Promise<string> }


  private isFormValid: boolean = true
  private fetchInProgress: boolean = false
  private loading: boolean = false
  private loginName: string = ''
  private password: string | null = null
  private showErrorSnackbar: boolean = false
  private showSavedSnackbar: boolean = false
  private isFetchInProgress: boolean = false
  private isCheckboxTrue: boolean = true
  private isChangePin: boolean = false

  private passwordRules: Array<(v: string) => string | boolean | TranslateResult> = [
    (v: string) => !!v || i18n.t('validation.valueIsRequired').toString(),
    (v: string) => !!v || i18n.t('validation.valueIsRequired').toString(),
    (v: string) => (v && v.length > 3)  || i18n.t('validation.passwordIsTooShort').toString(),
    (v: string) => {
      const pattern = /^[a-zA-Z0-9]*$/
      return pattern.test(v) || i18n.t('validation.valueIsRequiredMessage').toString()
    },
  ]

  private loginNameRules: Function[] = [
    valueIsRequired

  ]

  onFormSubmit(): void {
    if (this.form.validate()) {
        this.updatePersonCredentialPassword()
    }
  }

  generateCodeClick () {
    this.password = Math.floor(1000 + Math.random() * 9000).toString()
  }

  async fetchPersonCredentialId():Promise<void >{
    try {
      this.fetchInProgress = true
      this.$emit('fetchInProgress', this.fetchInProgress)
      this.loading = true
      this.loginName = await this.fetchPersonCredentialById(this.personId)
    } catch (e) {
      this.showErrorSnackbar = true
    } finally {
      this.fetchInProgress = false
      this.$emit('fetchInProgress', this.fetchInProgress)
      this.loading = false
    }
  }

  async updatePersonCredentialPassword(): Promise<void>{
    const payload: UpdatePasswordPayload = {
      personId: this.personId,
      password: this.password!,
      loginName: this.loginName,
      sendNotification: this.isCheckboxTrue,
      forcePasswordChange: this.isChangePin
    }

    try {
      this.isFetchInProgress = true
      this.$emit('fetchInProgress', this.isFetchInProgress)
      await this.updatePersonCredentialPassById(payload)
      this.showSavedSnackbar = true
    } catch (e) {
      this.showErrorSnackbar = true
    } finally {
      this.isFetchInProgress = false
      this.$emit('fetchInProgress', this.isFetchInProgress)
    }
  }
  mounted() {
    this.fetchPersonCredentialId()
  }
}

</script>

<style lang="stylus" scoped>

</style>
